import services from './services.js';
import products from './products.js';
import rawMaterials from './raw-materials.js';
import inventoryManufacturers from './inventory-manufacturers.js';
import inventoryCategories from './inventory-categories.js';
import billOfMaterials from './bill-of-materials.js';
import manufacturingOrders from './manufacturing-orders.js';
import warehouses from './warehouses.js';
import warehouseTransfers from './warehouse-transfers.js';

export default [...services, ...products, ...rawMaterials, ...inventoryManufacturers, ...inventoryCategories, ...billOfMaterials, ...manufacturingOrders, ...warehouses, ...warehouseTransfers];
